export default __webpack_public_path__ + "static/media/1m-logo.f533627f.svg";